import { Storage } from "@/services/Storage";
import axios from "axios";
import connectivityMonitor from '@/services/connectivityMonitor';

const findCachedInstruction = (list, plu) => {
    if (!Array.isArray(list)) return { groups: [] };
    const target = String(plu);

    const directMatch = list.find(item =>
        item &&
        (String(item.StockCode) === target || String(item.linkNum) === target)
    );
    if (directMatch) return directMatch;

    for (const item of list) {
        if (!item || !Array.isArray(item.groups)) continue;
        if (String(item.linkNum) === target) return item;

        const matchingGroups = item.groups
            .map(group => {
                if (!group || !Array.isArray(group.messages)) return null;
                const messages = group.messages.filter(m => String(m.StockCode) === target);
                if (!messages.length) return null;
                return { ...group, messages };
            })
            .filter(Boolean);

        if (matchingGroups.length) {
            return { ...item, groups: matchingGroups };
        }
    }

    return { groups: [] };
};

const findInstructionByCookingLink = (list, cookingLink) => {
    if (!Array.isArray(list) || cookingLink === undefined || cookingLink === null) {
        return { groups: [] };
    }
    const target = String(cookingLink);
    const match = list.find(item => item && String(item.linkNum) === target);
    return match || { groups: [] };
};

const upsertCachedInstruction = (list, instruction, plu) => {
    if (!Array.isArray(list)) list = [];
    if (!instruction || !Array.isArray(instruction.groups)) return list;

    const target = String(plu);
    let replaced = false;
    const next = list.map(item => {
        if (!item || !Array.isArray(item.groups)) return item;
        const hasMatch = item.groups.some(group =>
            Array.isArray(group.messages) &&
            group.messages.some(msg => String(msg.StockCode) === target)
        );
        if (hasMatch) {
            replaced = true;
            return instruction;
        }
        return item;
    });

    if (!replaced) next.push(instruction);
    return next;
};

export default {
    name: 'cooking_instruction',
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getCookingInstruction: async (context, payload) => {
            let store = await Storage.getDefaultStore();
            let online = true;
            try {
                online = connectivityMonitor.getStatus();
            } catch (e) { }

            if (!online) {
                const direct = await Storage.getCookingInstructionByPlu(payload);
                console.log('[cookingInstruction] offline direct cache', {
                    hasValue: !!direct,
                    isArray: Array.isArray(direct),
                    length: Array.isArray(direct) ? direct.length : undefined
                });
                if (Array.isArray(direct) && direct.length === 1) return direct[0];
                if (direct) return direct;
                const cached = await Storage.getCookingInstructions();
                console.log('[cookingInstruction] offline /all cache', {
                    isArray: Array.isArray(cached),
                    length: Array.isArray(cached) ? cached.length : undefined
                });
                if (Array.isArray(cached) && cached.length === 1) return cached[0];
                const stockItem = await Storage.getByPlu(payload);
                console.log('[cookingInstruction] offline stock item', stockItem);
                let cookingLink = stockItem?.StockSetting?.CookingLink ?? stockItem?.StockSetting?.cookingLink;
                if (cookingLink === undefined || cookingLink === null) {
                    const stockSetting = await Storage.getStockSetting(payload);
                    console.log('[cookingInstruction] offline stock setting', stockSetting);
                    cookingLink = stockSetting?.CookingLink ?? stockSetting?.cookingLink;
                }
                console.log('[cookingInstruction] offline cookingLink', cookingLink);
                const byLink = findInstructionByCookingLink(cached, cookingLink);
                if (byLink && byLink.groups) return byLink;
                return findCachedInstruction(cached, payload);
            }

            return axios.get(serverApi + `cookinginstruction/${store.StoreDB}/${payload}`)
                .then(async ({data}) => {
                    try {
                        await Storage.setCookingInstructionByPlu(payload, data);
                        const cached = await Storage.getCookingInstructions();
                        const next = upsertCachedInstruction(cached, data, payload);
                        await Storage.setCookingInstructions(next);
                    } catch (e) {
                        console.warn('[cookingInstruction] Failed to cache instruction:', e);
                    }
                    return data;
                })
                .catch(async (err) => {
                    console.warn('[cookingInstruction] online error, using cache', err?.message || err);
                    const direct = await Storage.getCookingInstructionByPlu(payload);
                    if (Array.isArray(direct) && direct.length === 1) return direct[0];
                    if (direct) return direct;
                    const cached = await Storage.getCookingInstructions();
                    if (Array.isArray(cached) && cached.length === 1) return cached[0];
                    const fallback = findCachedInstruction(cached, payload);
                    if (fallback && fallback.groups) return fallback;
                    return errorHandler.tomcatError(err)
                })
        }
    }
}
